import type { CSS } from '../../stitches.config';
import { type SpacingScale, isSpacingValue } from './sizes';

export type MinHeightTypes = 'full' | 'screen' | SpacingScale | string;
export type MinHeightProps = { minHeight?: MinHeightTypes };

export const minHeightCSS = (minHeight?: MinHeightTypes): CSS => {
  if (minHeight === 'full') {
    return { minHeight: '100%' };
  }

  if (minHeight === 'screen') {
    return { minHeight: '100dvh' };
  }

  if (typeof minHeight === 'number' && isSpacingValue(minHeight)) {
    return { minHeight: `$${minHeight}` };
  }

  if (typeof minHeight === 'string') {
    return { minHeight };
  }

  return {};
};
